import { render, staticRenderFns } from "./UpdateAnnouncementModal.vue?vue&type=template&id=242ec82c&scoped=true"
import script from "./UpdateAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./UpdateAnnouncementModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateAnnouncementModal.vue?vue&type=style&index=0&id=242ec82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242ec82c",
  null
  
)

export default component.exports